export default class Sticky {
    constructor(
        element,
        conditionFunc,
        { stickOriginalElement } = { stickOriginalElement: false },
    ) {
        this.originalEl = element;
        this.conditionFunc = conditionFunc;
        this.clonedEl = stickOriginalElement ? element : element.cloneNode(true);

        this.clonedEl.addEventListener('click', () => {
            const selClickable = 'input, button, a';
            const elClickable = element.matches(selClickable)
                ? element
                : element.querySelector(selClickable);

            if (elClickable) {
                elClickable.click();
            } else {
                console.error('clickable element is not found in the clone');
            }
        });

        window.APC_USC.add(this.clonedEl, { hidden: true });

        this.checkCondition();
    }

    destroy() {
        window.APC_USC.remove(this.clonedEl);
    }

    checkCondition() {
        if (this.conditionFunc) {
            const showHideFn = this.conditionFunc(this.originalEl, this.clonedEl) ? 'show' : 'hide';
            window.APC_USC[showHideFn](this.clonedEl);
        }
    }

    show() {
        window.APC_USC.show(this.clonedEl);
    }

    hide() {
        window.APC_USC.hide(this.clonedEl);
    }
}
